export const VoucherStatusMap: Record<string, string> = {
  "0": "Open",
  "1": "Paid",
  "2": "Cancelled",
  "3": "Non-Commissionable",
  "4": "No Show",
};